import styled from 'styled-components';

import { Form } from 'features/common/components/Form';
import { Text } from 'features/common/components/Text';
import { Button } from 'features/common/components/Button';

export const Subtitle = styled(Text)<{ isPunchup?: boolean }>`
	font-size: 24px;
	color: ${({ theme, isPunchup }) => (isPunchup ? theme.colors.grey8 : theme.colors.white)};

	@media screen and (max-width: ${({ theme }) => theme.breakpoints.sm}) {
		font-size: 12px;
		line-height: 16px;
	}
`;

export const FormContainer = styled(Form)<{ isPunchup?: boolean }>`
	display: flex;
	margin-left: ${({ theme, isPunchup }) => (isPunchup ? '0' : theme.widths.hiddenSidebar)};
	width: ${({ theme, isPunchup }) => (isPunchup ? '100%' : `calc(100% - ${theme.widths.hiddenSidebar})`)};

	@media screen and (max-width: ${({ theme }) => theme.breakpoints.md}) {
		flex-direction: column;
		align-items: center;
	}
`;

export const StickyDiv = styled.div<{ isPunchup?: boolean }>`
	background: ${({ theme, isPunchup }) => (isPunchup ? theme.colors.white : theme.colors.verticalUpGreyGradient2)};
	border-top: ${({ isPunchup }) => (isPunchup ? '1px solid #e5e5e5' : 'none')};
	display: flex;
	gap: 16px;
	justify-content: center;
	padding: 48px 0;
	position: sticky;
	bottom: 0;
	width: 100%;
`;

export const FormButton = styled(Button)<{ isPunchup?: boolean }>`
	background-color: ${({ theme, isPunchup }) =>
		isPunchup ? theme.colors.punchupOrange || '#fe5e25' : theme.colors.blackGrey};
	border: ${({ theme, isPunchup }) => (isPunchup ? `2px solid ${theme.colors.punchupOrange || '#fe5e25'}` : 'none')};
	color: ${({ theme, isPunchup }) => (isPunchup ? theme.colors.white : theme.colors.white)};
	font-size: 18px;
	font-weight: 600;
	line-height: normal;
	margin: 0;
	padding: 8px 16px;
	max-width: 300px;

	&:hover {
		opacity: 0.9;
	}
`;
